import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';

export const ReportText = styled(Typography)<{ $isReported: boolean }>`
  ${({ $isReported, theme }) =>
    $isReported &&
    css`
      color: ${theme.colors.systemColors.red};
    `}
`;

export const ReportSectionContainer = styled(FlexibleDiv)<{
  $isReported: boolean;
}>`
  height: 50px;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.primary};
  cursor: pointer;

  ${ReportText} {
    transition: color 0.3s ease;
  }

  path {
    transition: fill 0.3s ease;
  }

  @media (hover: hover) {
    &:hover {
      ${({ theme }) => css`
        ${ReportText} {
          color: ${theme.colors.systemColors.red};
        }

        path {
          fill: ${theme.colors.systemColors.red};
        }
      `}
    }
  }

  ${({ $isReported, theme }) =>
    $isReported &&
    css`
      path {
        fill: ${theme.colors.systemColors.red};
      }
    `}

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    height: 54px;
    width: 54px;
    padding: 0;
    justify-content: center;
    align-items: start;
    padding-top: 8px;
    background-color: transparent;
  }
`;
